import styled from 'styled-components'
import {COLOR} from 'src/service/constant/color'
import {customMedia} from "src/styles/common/common"

const JoinWrap = styled.div`
  display: block;
  margin: 0 auto;
    
  .alert-wrap{
    margin: 24px auto 227px auto;
    text-align: center;

    font-family: NotoSansRegular, sans-serif;
    
    ${customMedia.lessThan('tablet_cut_line')`
      font-size: 12px;
      margin: 12px auto 83px auto;
    `}
    
    ul{
      display: flex;
      flex-flow: column;
      padding:0;
      margin:0;
      li{
        list-style: none;
        color: ${COLOR.point1};
        font-size: 14px;
        font-weight: 400;
        font-style: normal;
        line-height: normal;
        &.bold{
          font-weight: 700;
        }
        ${customMedia.lessThan('tablet_cut_line')`
          font-size: 12px;
        `}
      }
    }
  }
`

const JoinTermsWrap = styled.div`
  display: block;
  width: 600px;
  margin: 0 auto;
  ${customMedia.lessThan('tablet_cut_line')`
       max-width: 600px;
       width: 100%;
       margin-top: -10px;
   `}
`

const JoinTermsAll = styled.div`
  display: flex;
  margin-bottom: 19.5px; 
  ${customMedia.lessThan('tablet_cut_line')`
        margin-bottom: 12px;
   `}
  > img {
    display: flex;
    width: 26px;
    height: 26px;
    cursor: pointer;
    ${customMedia.lessThan('tablet_cut_line')`
         width: 20px;
         height: 20px;
   `}
  }

  > span {
    margin-left: 8px;
    font-family: NotoSansRegular, sans-serif;
    font-size: 14px;
    line-height: 26px;
    ${customMedia.lessThan('tablet_cut_line')`
        font-size: 12px;
        line-height: 20px;
        white-space: pre-line;
   `}
  }
`
const JoinTermsSome = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 12px; 
  ${customMedia.lessThan('tablet_cut_line')`
     display: block;
  `}

  > div {
    display: flex;
    > img {
      width: 20px;
      height: 20px;
      display: flex;
      cursor: pointer;
    }

    > p {
      margin: 0 4px 12px 4px;
      line-height: 20px;
      font-size: 12px;
      font-family: NotoSansRegular, sans-serif;
    }

    > span {
      cursor: pointer;
      line-height: 20px;
      font-size: 12px;
      color: ${COLOR.sub1};
      text-decoration: underline;
    }
  }
`
export {JoinWrap, JoinTermsWrap, JoinTermsAll, JoinTermsSome}
